module.exports = __webpack_public_path__ + "static/media/YF97_6.d82dfe06.jpg";